import { buildCsvString, triggerCsvDownload } from "../../shared/csv_download";
import { wireDatePicker } from "../../../../shared/date_picker";

document.addEventListener('alpine:init', () => {
  Alpine.data('PrefixDownloadsByTimeOfDay', () => ({
    apiUrl: null,
    chart: null,
    init() {
      const root = this.$el || document;
      const wrapper = root.closest('[data-time-of-day-root]') || root;
      this.apiUrl = (wrapper?.dataset?.apiUrl) || '/analytics/chart';
      try {
        this.pickerApi = wireDatePicker({
          rootEl: this.$el || document,
          onChange: () => this.fetchAndRender(),
          inputSelector: '#time-range',
          buttonSelector: '#__none__',
          hiddenFromSelector: '#time_from',
          hiddenToSelector: '#time_to',
          maxDate: 'today',
          activeClasses: { add: ['bg-quill-100'], remove: ['bg-white'] }
        });
        const input = (this.$el || document).querySelector('#time-range');
        const clearBtn = (this.$el || document).querySelector('#time-clear');
        const fromEl = (this.$el || document).querySelector('#time_from');
        const toEl = (this.$el || document).querySelector('#time_to');
        const syncClear = () => {
          try { if (clearBtn) (input && input.value && input.value.trim()) ? clearBtn.classList.remove('hidden') : clearBtn.classList.add('hidden'); } catch (_) {}
        };
        if (input) { input.addEventListener('input', syncClear); input.addEventListener('change', syncClear); setTimeout(syncClear, 0); }
        if (clearBtn) {
          clearBtn.addEventListener('click', () => {
            try { if (input) input.value=''; if (fromEl) fromEl.value=''; if (toEl) toEl.value=''; } catch(_) {}
            syncClear();
            this.fetchAndRender();
          });
        }
      } catch (_) {}
      this.fetchAndRender();
      const dlBtn = root.querySelector('#prefix-time-csv');
      if (dlBtn) {
        dlBtn.addEventListener('click', async () => {
          try {
            const params = new URLSearchParams();
            params.append('chart_type', 'audience_downloads_time_of_day');
            try {
              const from = (this.$el || document).querySelector('#time_from')?.value;
              const to = (this.$el || document).querySelector('#time_to')?.value;
              if (from && to) {
                params.append('date_range', 'custom');
                params.append('start_date', from);
                params.append('end_date', to);
              } else {
                params.append('date_range', 'all_time');
              }
            } catch (_) { params.append('date_range', 'all_time'); }
            const res = await fetch(`${this.apiUrl}?${params.toString()}`, { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
            if (!res.ok) throw new Error(`time_of_day csv fetch failed ${res.status}`);
            const data = await res.json();
            const labels = Array.isArray(data?.labels) ? data.labels : [];
            const series = Array.isArray(data?.series) ? data.series : [];
            const rows = [];
            for (let i = 0; i < labels.length; i++) rows.push([labels[i], Number(series[i] || 0)]);
            const csv = buildCsvString(['Time', 'Downloads'], rows);
            triggerCsvDownload(csv, 'downloads_by_time_of_day.csv');
          } catch (e) { console.error('time_of_day csv error', e); }
        });
      }
      window.addEventListener('turbo:before-cache', () => this.destroy());
    },
    destroy() {
      try { this.chart && this.chart.destroy && this.chart.destroy(); } catch (_) {}
      this.chart = null;
    },
    buildParams() {
      const params = new URLSearchParams();
      params.append('chart_type', 'audience_downloads_time_of_day');
      try {
        const from = (this.$el || document).querySelector('#time_from')?.value;
        const to = (this.$el || document).querySelector('#time_to')?.value;
        if (from && to) {
          params.append('date_range', 'custom');
          params.append('start_date', from);
          params.append('end_date', to);
          return params;
        }
      } catch (_) {}
      params.append('date_range', 'all_time');
      return params;
    },
    async fetchAndRender() {
      const params = this.buildParams();
      try {
        const res = await fetch(`${this.apiUrl}?${params.toString()}`, { headers: { 'Accept': 'application/json' }, cache: 'no-store' });
        if (!res.ok) throw new Error(`Fetch failed ${res.status}`);
        const data = await res.json();
        const labels = Array.isArray(data?.labels) ? data.labels : [];
        const series = Array.isArray(data?.series) ? data.series : [];
        const hasData = labels.length > 0 && series.length > 0;
        const el = document.querySelector('#prefix-when-they-listen');
        const noDataEl = document.querySelector('#prefix-when-they-listen-no-data');

        if (!hasData) {
          if (el) el.innerHTML = '';
          if (noDataEl) noDataEl.removeAttribute('hidden');
          return;
        }
        if (noDataEl) noDataEl.setAttribute('hidden', '');

        const options = {
          colors: ["#391599"],
          series: [{ name: 'Downloads', data: series }],
          chart: {
            toolbar: { show: false },
            type: 'bar',
            height: 380,
            fontFamily: 'manrope'
          },
          dataLabels: { enabled: false },
          stroke: { show: true, width: 2, colors: ['transparent'] },
          xaxis: { categories: labels, tickPlacement: 'on' }
        };
        if (this.chart) { try { this.chart.destroy(); } catch (_) {} }
        this.chart = new ApexCharts(el, options);
        this.chart.render();
      } catch (e) { console.error('audience_downloads_time_of_day fetch error', e); }
    }
  }));
});
